import React from "react";
import { Button } from "reactstrap";

export default function WritingPreviewLiveValidationBanner({
	variant = "initial",
	fixedCount = 0,
	totalCount = 0,
	isSubmitting = false,
	isPolling = false,
	statusLabel = null,
	onVerify,
	// When true (user has unsaved edits or save is in progress): disable button
	verifyDisabledByEdits = false,
}) {
	const isBusy = isSubmitting || isPolling;
	const isInitial = variant === "initial";

	// Title & subtitle untouched – exactly as before. Do not change wording when edits exist.
	const title = isInitial
		? "Ready to check your live site?"
		: "Deployed on your live site?";

	const subtitle =
		isPolling && statusLabel
			? statusLabel
			: isInitial
				? "After you publish the suggested edits, verify whether each change appears on your live page."
				: `${fixedCount}/${totalCount} changes fixed on live page. Re-run to refresh after new deploys.`;

	const buttonLabel = isInitial ? "Verify live content" : "Re-verify live content";
	const busyLabel = isPolling ? statusLabel || "Verifying…" : "Submitting…";
	const disabled = isBusy || verifyDisabledByEdits;
	const disabledTooltip = verifyDisabledByEdits
		? isSubmitting
			? "Save in progress – verify will unlock momentarily."
			: "Save your edits first, then verify the refreshed preview on your live site."
		: "";

	return (
		<div className="writing-preview__live-validation">
			<div className="writing-preview__live-validation-text">
				<h3 className="writing-preview__live-validation-title">{title}</h3>
				<p className="writing-preview__live-validation-subtitle mb-0">{subtitle}</p>
				{verifyDisabledByEdits && !isBusy && (
					<p className="writing-preview__live-validation-note mb-0">
						<i className="fas fa-info-circle me-1" />
						{disabledTooltip}
					</p>
				)}
			</div>
			<Button
				color="primary"
				className="writing-preview__live-validation-btn"
				size="sm"
				disabled={disabled}
				title={disabled ? disabledTooltip || undefined : undefined}
				onClick={onVerify}
			>
				{isBusy ? (
					<>
						<span
							className="spinner-border spinner-border-sm me-1"
							role="status"
							aria-hidden="true"
						/>
						{busyLabel}
					</>
				) : (
					<>
						<i className="fas fa-clipboard-check me-1" />
						{buttonLabel}
					</>
				)}
			</Button>
		</div>
	);
}
